import React, { Fragment, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  logoutAPI,
  getAllHistory,
  adjustmentDefaultValues,
} from "../../Services/ApiServices";
import { toast } from "react-toastify";
import logo from "../../Common/img/header-logo.png";
import logo2 from "../../Common/img/header-logo2.png";
import Dropdown from "react-bootstrap/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import {
  csvNewData,
  changeDefaultValues,
  CountValue,
  review_data,
  formula_Division_DefaultValue,
  report_data,
  base64ImagesData,
  loginState,
  propertyImages,
  selectedPropertydata,
  selectedPropertydataUUID,
  addressTitle,
  userAddedDefaultValues,
  allCsvData,
  selectedAdditionalInfo,
  comaparableData,
  selectPropertyList,
  adjustmentFormulas,
  ListArray,
  InputAddressState,
  businessImage,
  pageChecked,
  UploadCSVFlag,
  selectedPropertyAddress,
  clientName,
  ReportName,
  propertyPriceRange,
} from "../../Redux/actions";
import "./Header.scss";
import Loader from "../../Components/Loader/Loader";
import { changeFormateOfApiData, defaultStateValue } from "../../utils/helper";

const Header = (props) => {
  const [historydata, setHistoryData] = useState([]);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const profilePic = useSelector((state) => state?.Login?.profileImage);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const historyUpdate = (e) => {
    try {
      defaultValuesApiCallAandData();
      const test = JSON.parse(e.state);
      console.log("Parsed history data:", test);

      // Ensure csvNewData is an array (converts object to array if needed)
      const csvData = Array.isArray(test.csvNewData) ? test.csvNewData : [test.csvNewData];

      // Dispatch all data with proper defaults
      dispatch(csvNewData(csvData));
      dispatch(changeDefaultValues(test.changeDefaultValues || {}));
      dispatch(CountValue(test.count || 0));
      dispatch(review_data(test.review_data || {}));
      dispatch(formula_Division_DefaultValue(test.formula_Division_DefaultValue || {}));
      dispatch(report_data(test.report_data || {}));
      dispatch(selectedPropertydata(test.selectedPropertydata || []));
      dispatch(selectedPropertydataUUID(test.selectedPropertydataUUID));
      dispatch(addressTitle(test?.address || ""));
      dispatch(selectedPropertyAddress(test?.selectedPropertyAddress || ""));
      dispatch(pageChecked(test?.checked || []));
      dispatch(allCsvData(test.allCsvData || []));
      dispatch(selectedAdditionalInfo(test.selectedAdditionalInfo || []));
      dispatch(propertyImages(test.propertyImages || {}));
      dispatch(comaparableData(test.comaparables || []));
      dispatch(selectPropertyList(test.selectPropertyList || []));
      dispatch(adjustmentFormulas(test.adjustment_formulas || {}));
      dispatch(ListArray(test.listing_id_arr || []));
      dispatch(InputAddressState(test.inputAddressState || ""));
      dispatch(businessImage(test.businessImages || {}));
      dispatch(UploadCSVFlag(test.isUploadCSV || false));
      dispatch(base64ImagesData(test.base64Images || {}));
      dispatch(clientName(test.clientName || ""));
      dispatch(ReportName(test.reportName || ""));
      dispatch(propertyPriceRange(test.range || {}));
      navigate("/confirm-subject");
    } catch (error) {
      console.error("Error loading history:", error);
      navigate("/confirm-subject");
    }
  };
  const defaultValuesApiCallAandData = () => {
    adjustmentDefaultValues()
      .then((res) => {
        if (res.status_code === 200) {
          if (res.data) {
            const userdataAPIdata = Object.entries(
              res.data.user_property_adjustment_value
            ).map((e) => e[1]);

            let userAddedValues = changeFormateOfApiData(
              userdataAPIdata,
              defaultStateValue
            );
            if (Object.values(userAddedValues).length <= 17) {
              dispatch(userAddedDefaultValues(userAddedValues));
            }
          }
        } else {
          if (res.data && res.data.error) {
            toast.error(res.data.error);
          }
        }
      })
      .catch((error) => { });
  };

  const logout = (e) => {
    e.preventDefault();
    logoutAPI()
      .then((res) => {
        if (res.status_code === 200) {
          dispatch(propertyImages([]));
          dispatch(base64ImagesData([]));
          toast.success("User Logged out Successfully");
          localStorage.clear();
          navigate("/login");
          dispatch(loginState("login"));
        } else {
          if (res.data && res.data.error) {
            toast.error(res.data.error);
          } else {
            for (var iRow in res.data) {
              if (Object.keys(res.data[iRow]).length >= 1) {
                for (var jRow in res.data[iRow]) {
                  toast.error(res.data[iRow][jRow]);
                }
              }
            }
          }
        }
      })
      .catch(() => {
        toast.error("Something went wrong.");
        return false;
      });
  };

  // getAll history  api
  const getHistoryApi = () => {
    setLoader(true);
    getAllHistory(page)
      .then((res) => {
        if (res.status_code === 200) setHistoryData(res.data.data);
        if (res.data.next_page_url == null) {

          setPageCount(true)
        } else {
          setPageCount(false)
        }
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
      });
  };
  useEffect(() => {
    const testtoken = localStorage.getItem("token");
    if (testtoken) {
      getHistoryApi();
    }
  }, [page]);

  // pagination
  // handle prev btn
  const handlePrevious = () => {
    setPage(() => {
      if (page === 1) return page;
      return page - 1
    })
  }

  // handle next btn
  const handleNext = () => {
    setPage(() => {
      if (pageCount) return page;
      return page + 1
    })
  }

  const handleFAQClick = () => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollToFAQ: true } });
    } else {
      props.scrollToFAQ();
    }
  };

  return (
    <Fragment>
      <div className="header-page">
        {!props.isLandingHeader ? (
          <nav className="navbar navbar-expand-lg navbar-light">
            <Link to={"/home"} className="navbar-brand">
              <img src={logo} alt="logo" />
            </Link>
            <div className="navbar-center" style={{ color: "#ff05e8", fontWeight: "500" }}>
              <span>Customer support</span>
              <p>303-717-1283</p>
            </div>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon mt-1"></span>
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ml-auto">
                <li>
                  <Link
                    className={
                      location.pathname === "/home"
                        ? "nav-link activeNav"
                        : "nav-link"
                    }
                    to="/home"
                  >
                    CMA
                    <span className="sr-only">(current)</span>
                  </Link>
                </li>
                <li>
                  <Link
                    className={
                      location.pathname === "/market-position"
                        ? "nav-link activeNav"
                        : "nav-link"
                    }
                    to="/market-position"
                  >
                    Market Position
                    <span className="sr-only">(current)</span>
                  </Link>
                </li>
                <Dropdown className="dropdown">
                  <Dropdown.Toggle
                    variant=""
                    style={{
                      background: "transparent",
                      color: "#1a28a2",
                      fontWeight: "500",
                    }}
                  >
                    HISTORY
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="menu">
                    {loader ? (
                      <Loader width={"50px"} height={"50px"} />
                    ) : (
                      <>

                        {
                          historydata?.map((element) => {
                            return (
                              <Dropdown.Item
                                onClick={() => historyUpdate(element)}
                              >
                                {element.address}
                              </Dropdown.Item>
                            );
                          })
                        }
                        <div className="d-flex justify-content-between m-1">
                          <p style={{ width: "50px", textAlign: "center", padding: "3px", cursor: page === 1 ? "default" : "pointer", color: page === 1 ? "lightgray" : "black" }} onClick={() => handlePrevious()}><i className="fa-solid fa-caret-left"></i></p>
                          <p style={{ width: "50px", textAlign: "center", padding: "3px", cursor: pageCount ? "default" : "pointer", color: pageCount ? "lightgray" : "black" }} onClick={() => handleNext()}><i className="fa-solid fa-caret-right"></i></p>
                        </div>

                      </>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
                <li>
                  <Link
                    to="/change-default-values"
                    className={
                      location.pathname === "/change-default-values"
                        ? "nav-link activeNav"
                        : "nav-link"
                    }
                  >
                    Change default values
                  </Link>
                </li>

                <li>
                  <Link
                    className={
                      location.pathname === "/faqs"
                        ? "nav-link activeNav"
                        : "nav-link"
                    }
                    to="/faqs"
                  >
                    FAQS
                    <span className="sr-only">(current)</span>
                  </Link>
                </li>
                <li className="navItem">
                  <a className="nav-link" onClick={logout} href="/#">
                    Log Out
                  </a>
                </li>
                <li className="navItem">
                  <span className="navItem">
                    <Link to="/edit-profile">
                      <img
                        alt="profile pic"
                        src={profilePic ? profilePic : "/user.png"}
                        className="user-img"
                      />
                    </Link>
                  </span>
                </li>
              </ul>
            </div>
          </nav>
        ) : (
          <div className="container c-container">
            <nav className="navbar navbar-expand-lg navbar-light border-0">
              {/* LEFT: Logo */}
              <div className="navbar-left">
                <Link to="/home" className="navbar-brand">
                  <img src={logo2} alt="logo" />
                </Link>

              </div>
              <div className="navbar-center" style={{ color: "#ff05e8", fontWeight: "500" }}>
                <span>Customer support</span>
                <p>303-717-1283</p>
              </div>

              {/* Toggle Button for Mobile */}
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon mt-1"></span>
              </button>

              {/* CENTER: Navigation Links */}
              <div className="collapse navbar-collapse justify-content-center" id="navbarSupportedContent">
                <ul className="navbar-nav">
                  <li className={location.pathname === "/" ? "navItem activeNav" : "navItem"}>
                    <Link
                      to="/"
                      className={location.pathname === "/" ? "nav-link activeNav" : "nav-link"}
                    >
                      Home
                    </Link>
                  </li>

                  <li className="navItem">
                    <Link
                      to="/about-us"
                      className={location.pathname === "/about-us" ? "nav-link activeNav" : "nav-link"}
                    >
                      About Us
                    </Link>
                  </li>

                  <li className="navItem">
                    <Link
                      to="/contact-us"
                      className={location.pathname === "/contact-us" ? "nav-link activeNav" : "nav-link"}
                    >
                      Contact Us
                    </Link>
                  </li>

                  <li className="navItem">
                    <Link
                      to="/subscription-plan"
                      className={location.pathname === "/subscription-plan" ? "nav-link activeNav" : "nav-link"}
                    >
                      Subscription
                    </Link>
                  </li>

                  <li className="navItem">
                    <div
                      style={{
                        cursor: "pointer",
                        color: isHovered ? "#ff05e8" : "#1d22a9",
                        marginTop: "8px",
                        fontWeight: "500",
                        padding: "0 7px",
                      }}
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                      onClick={handleFAQClick}
                    >
                      FAQ
                    </div>
                  </li>
                </ul>

                {/* Mobile/Tablet Buttons - Inside Sidebar */}
                <div className="mobile-buttons d-lg-none mt-3">
                  <button
                    className="btn btn-blue btn-outline-success w-100 mb-2 custom-rounded-btn"
                    onClick={() => {
                      navigate("/login");
                      dispatch(loginState("login"));
                    }}
                  >
                    Sign in
                  </button>
                  <button
                    className="btn btn-blue btn-outline-success w-100 mb-3 custom-rounded-btn"
                    onClick={() => {
                      navigate("/subscription-plan");
                      dispatch(loginState("register"));
                    }}
                  >
                    Sign up
                  </button>
                </div>
              </div>

              {/* Desktop Buttons */}
              <div className="navbar-buttons d-none d-lg-flex">
                <button
                  className="btn btn-blue btn-outline-success mx-1 mb-1 custom-rounded-btn"
                  onClick={() => {
                    navigate("/login");
                    dispatch(loginState("login"));
                  }}
                >
                  Sign in
                </button>

                <button
                  className="btn btn-blue btn-outline-success mx-1 custom-rounded-btn"
                  onClick={() => {
                    navigate("/subscription-plan");
                    dispatch(loginState("register"));
                  }}
                >
                  Sign up
                </button>
              </div>
            </nav>
          </div>

        )}
      </div>
    </Fragment>
  );
};

export default Header;
